var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V341.992H0V-0.0078125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.8 170.992L513 30.1922V-0.0078125H467.7L256.5 140.792L45.3 -0.0078125H0V30.1922L211.2 170.992L0 311.792V341.992H45.3L256.5 201.192L467.7 341.992H513V311.792L301.8 170.992Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.7 44.592L256 50.192L278.3 44.592L282.3 23.692L267.4 30.192L256 14.792L244.6 30.192L229.7 23.692L233.7 44.592Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.7 44.5918C233.7 44.5918 229.7 57.4918 229.7 74.4918C229.7 102.392 256 115.792 256 115.792C256 115.792 282.3 100.292 282.3 74.4918C282.3 59.0918 278.3 44.5918 278.3 44.5918C278.3 44.5918 270.2 39.5918 256 39.5918C241.8 39.5918 233.7 44.5918 233.7 44.5918Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJe);
export default __webpack_public_path__ + "static/media/JE.cf8711fad64ce11a46777c667b2529dd.svg";
export { ForwardRef as ReactComponent };